<template>
  <section class="page-wrap">
    <!-- 顶部操作 start -->
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="formData"
      @Refresh="onHandleRefresh"
      @search="onHandleSearch"
    >
      <template v-slot:right>
        <el-button
          @click="exportHandle"
          :disabled="disabledExport"
          type="warning"
          icon="el-icon-upload2"
          >导出</el-button
        >
      </template>
    </Filtersearch>

    <!-- 列表 start -->
    <section class="content-wrap">
      <table-list v-loading="loadingData" :tableData="tableData"></table-list>
    </section>
    <!-- 列表 end -->

    <!-- 分页 start -->
    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </section>
</template>
<script>
import {
  getSupplierSelectList,
  postBuyerSelectList,
} from "@/api/general/operation-center/index";
import { postSettlementOrderPromotionList } from "@/api/generalControl/promotion.js";
import TableList from "./modules/table-list/index.vue";
import cloneDeep from "lodash/cloneDeep";
import Filtersearch from "@/components/Filtersearch.vue";
import { postSettlementOrderPromotionListExport } from "@/api/export/center.js";
import { formatDate } from "@/utils//tools/date.js";

export default {
  name: "reward-settlement-detail",
  components: { TableList, Filtersearch },
  data() {
    return {
      total: 0,
      loadingData: false,
      formData: {
        page: 1,
        pageSize: 100,
        buyer_id: "",
        supplier_id: "",
        logistics_business_id: "",
        supply_time_start: "",
        supply_time_end: "",
        supply_time: [],
        time: [],
        settlement_time_start: "",
        settlement_time_end: "",
        supplier_order_no: "",
        order_no: "",
        product_title: "",
        sku_code: "",
        tdc_id: "",
      },
      formDataClone: {}, // 复制数据，用于初始化
      tableData: [], //列表数据
      Filtersearchlist: [
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          filterable: true,
          model: "logistics_business_id",
          placeholder: "请选择集配中心",
          selectoptionname: "logistic_business_list",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "供应商",
          clearable: true,
          filterable: true,
          model: "supplier_id",
          placeholder: "请选择供应商",
          selectoptionname: "supplier_id_list",
          label: "title",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "业务",
          clearable: true,
          filterable: true,
          model: "buyer_id",
          placeholder: "请选择业务",
          selectoptionname: "buyerList",
          label: "fullname",
          value: "id",
          selectoption: [],
        },
        {
          type: "input",
          name: "供货单号",
          clearable: true,
          model: "supplier_order_no",
          placeholder: "请输入供货单号",
        },
        {
          type: "daterange",
          name: "结算日期",
          clearable: true,
          model: "time",
          startmodel: "settlement_time_start",
          endmodel: "settlement_time_end",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
        },
        {
          type: "daterange",
          name: "供货日期",
          clearable: true,
          model: "supply_time",
          startmodel: "supply_time_start",
          endmodel: "supply_time_end",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
        },
        {
          type: "input",
          name: "订单号",
          clearable: true,
          model: "order_no",
          placeholder: "请输入订单号",
        },
        {
          type: "input",
          name: "商品名称",
          clearable: true,
          model: "product_title",
          placeholder: "请输入商品名称",
        },
        {
          type: "input",
          name: "商品货号",
          clearable: true,
          model: "sku_code",
          placeholder: "请输入商品货号",
        },
        {
          type: "select",
          name: "城市仓",
          clearable: true,
          filterable: true,
          model: "tdc_id",
          placeholder: "请选择城市仓",
          label: "name",
          value: "id",
          selectoptionname: "cityList",
          selectoption: [],
        },
      ],
      disabledExport: false,
    };
  },
  created() {
    this.formDataClone = cloneDeep(this.formData);
    this.formData.supplier_order_no = this.$route.query.supplier_order_no
      ? this.$route.query.supplier_order_no
      : "";
    this.formData.sku_code = this.$route.query.sku_code
      ? this.$route.query.sku_code
      : "";
    this.formData.settlement_time_start = this.$route.query.jump_time
      ? this.$route.query.jump_time
      : "";
    this.formData.settlement_time_end = this.$route.query.jump_time
      ? this.$route.query.jump_time
      : "";
    this.formData.time = this.$route.query.jump_time
      ? [this.$route.query.jump_time, this.$route.query.jump_time]
      : [];
    this.formData.tdc_id = this.$route.query.tdc_id
      ? Number(this.$route.query.tdc_id)
      : "";
    if (this.$route.query.tdc_id) {
      this.Filtersearchlist.forEach((el) => {
        if (
          el.type == "select" &&
          el.selectoptionname &&
          el.selectoptionname == "cityList"
        ) {
          el.selectoption = [
            {
              id: Number(this.$route.query.tdc_id),
              name: this.$route.query.tdc_name,
            },
          ];
        }
      });
    }

    console.log(this.formData, this.$route.query.tdc_id, " this.formData");

    this.formData.supply_time = this.getLastMonthRange();
    this.formData.supply_time_start = this.getLastMonthRange()[0];
    this.formData.supply_time_end = this.getLastMonthRange()[1];
    this.initData();
  },
  methods: {
    /**
     * 获取近一个月的起止日期（格式化后）
     * @param {string} format - 日期格式，默认'YYYY-MM-DD'
     * @returns {Array} [startDate, endDate] - 格式化后的起止日期数组
     */
    getLastMonthRange(format = "YYYY-MM-DD") {
      // 结束日期：今天
      const endDate = new Date();
      // 开始日期：一个月前的今天
      const startDate = new Date();
      startDate.setMonth(startDate.getMonth() - 1);

      // 使用formatDate格式化日期
      const start = formatDate(startDate, format);
      const end = formatDate(endDate, format);

      return [start, end];
    },
    /**
     * 导出明细
     */
    async exportHandle() {
      this.disabledExport = true;
      try {
        const query = {
          ...this.formData,
          token: sessionStorage.getItem("token"),
        };
        delete query.page;
        delete query.pageSize;
        await postSettlementOrderPromotionListExport(query);
        this.goExportCenter();
      } catch (err) {
        this.disabledExport = false;
        console.log("ajax postSettlementOrderPromotionListExport err", err);
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    /**
     * 获取供应商下拉列
     */
    async ajaxGetSupplierSelectList() {
      try {
        const { data } = await getSupplierSelectList();
        this.supplierList = data;
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "supplier_id_list"
          ) {
            // console.log(el.selectoptionname,res.data[el.selectoptionname])
            el.selectoption = data;
          }
        });
      } catch (err) {
        console.log("ajax getSupplierSelectList err", err);
      } finally {
      }
    },
    /**
     * 获取业务下拉列
     */
    async postAjaxBuyerSelectList() {
      // this.loadingBuyerList = true;
      try {
        const { data } = await postBuyerSelectList();
        this.buyerList = data;
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "buyerList"
          ) {
            // { id: "", fullname: "全部" },
            el.selectoption = [...data];
          }
        });
      } catch (err) {
        console.log("ajax postBuyerSelectList err", err);
      } finally {
        // this.loadingBuyerList = false;
      }
    },
    /**
     * 获得集配中心列表
     */
    async ajaxGetBusinessList() {
      try {
        const { data } = await this.$api.general.businessList();
        this.businessList = data;
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "logistic_business_list"
          ) {
            // console.log(el.selectoptionname,res.data[el.selectoptionname])

            el.selectoption = data;
          }
        });
        console.log("ajax ajaxGetBusinessList", data);
      } catch (err) {
        console.log("ajax ajaxGetBusinessList err", err);
      }
    },
    // 获取城市仓列表
    async citylist() {
      try {
        const res = await this.$api.general.logisticsList({
          name: "",
          page: 1,
          pageSize: 1000,
        });
        console.log(res, "res");
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "cityList"
          ) {
            el.selectoption = [...res.data];
          }
        });
      } catch (error) {
        console.log(error, "logisticsList");
      }
    },
    /**
     * 每页条数发生改变
     */
    onHandleSizeChange(val) {
      this.formData.pageSize = val;
      this.postAjaxSettlementOrderPromotionList();
    },
    /**
     * 页码发生改变
     */
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.postAjaxSettlementOrderPromotionList();
    },
    /**
     * 查询
     */
    onHandleSearch(e) {
      this.formData = e;
      this.formData.page = 1;
      this.postAjaxSettlementOrderPromotionList();
    },
    /**
     * 初始化数据
     */
    initData() {
      this.postAjaxSettlementOrderPromotionList();
      this.ajaxGetBusinessList();
      this.postAjaxBuyerSelectList();
      this.ajaxGetSupplierSelectList();
      this.citylist();
    },
    /**
     * 重置数据
     */
    onHandleRefresh() {
      this.formData = {
        ...this.formDataClone,
      };
      this.postAjaxSettlementOrderPromotionList();
    },
    /**
     * 获得列表数据
     */
    async postAjaxSettlementOrderPromotionList() {
      this.loadingData = true;
      try {
        const { data } = await postSettlementOrderPromotionList(this.formData);
        this.tableData = data.data;
        this.total = data.total;
      } catch (err) {
        console.error("ajax postSettlementOrderPromotionList err", err);
      } finally {
        this.loadingData = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  .form {
    padding: 13px 15px;
  }
  .content-wrap {
    flex: 1;
    overflow-y: hidden;
  }
  .pagination {
    box-sizing: border-box;
    padding: 10px 20px;
  }
  .headSearch {
    flex: 1;
    justify-content: end;
    gap: 15px;
  }
}
.top-tip {
  line-height: 30px;
  color: $danger-color;
  margin-left: 20px;
}
</style>
